<div class="specific-container">
  <div class="entity-name overflow-ellipsis">{{ item.result.name }}</div>
  <div class="entity-trigram">
    @if (item.result.entityShortId) {
      {{ item.result.entityShortId }}
    } @else {
      <aa-icon-circle class="danger duotone" [faIcon]="'fas fa-exclamation'" title="The entity has no short id">
      </aa-icon-circle>
    }
  </div>
</div>
